<div class="esn-segmented" role="radiogroup" [attr.aria-label]="ariaLabel()" [attr.aria-disabled]="isDisabled() || null">
  @for (option of options(); track option.value; let i = $index) {
    <button
      type="button"
      role="radio"
      class="esn-segmented__segment"
      [class.esn-segmented__segment--selected]="option.value === value()"
      [attr.aria-checked]="option.value === value()"
      [disabled]="isDisabled() || option.disabled"
      [tabIndex]="i === tabStop() ? 0 : -1"
      (click)="select(i)"
      (keydown)="handleKeydown($event, i)"
      (blur)="handleBlur()"
    >
      @if (option.icon; as icon) {
        <esn-icon [name]="icon" [size]="16" />
      }
      {{ option.label }}
    </button>
  }
</div>
